var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-create-layout',[_c('auction-statuses-form',{attrs:{"item":_vm.item,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }